import api from './BaseApi';

export function getSpecialMenu(id) {
  id = id || 'c8018c3f-f447-4a56-bc9a-6ca0f5b1ab78'
  return api.get(`recipe_set/${id}`);
}

export function getSpecialMenuTags(id) {
  id = id || 'c8018c3f-f447-4a56-bc9a-6ca0f5b1ab78'
  return api.get(`recipe_set_tags/${id}`);
}

export function setDateAndMealType(payload) {
  return api.post('set_meal/update', payload)
}
